module.exports = __webpack_public_path__ + "img/bti-dark.2231228a.png";